export default "__VITE_ASSET__C1ztuSc5__"